export const globalSettingsContextKey = "globalSettings";

export interface GlobalSettings {
	VERSION: string;
	ENV: string;
	ENV_DOMAIN: string;
	ROBOTS: "index" | "noindex";
	STORAGE_URL: string;
	UPLOAD_URL: string;
	WEB_URL: string;
	COOKIES: string;
	GOOGLE_ANALYTICS: string;
	MAIN_DOMAIN: string;
}
